import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import {
  CardContainer,
  CardBody,
  CardItem,
} from "../../ui/3d-card";

export const ProjectCard = ({ imgUrl, link, alt }) => {
  return (
  <Col xs={12} sm={6} md={4}>
      <div
        className="product-Solar1"
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-easing="ease-in-sine"
        data-aos-duration="600"
      >
        <Link to={link} className="proj-link">
          {/* 3D CARD */}
          <CardContainer containerClassName="product-card-container">
            <CardBody className="product-card-body">
              <CardItem translateZ={60}>
                <img src={imgUrl} alt={alt} className="product-image" />
              </CardItem>
            </CardBody>
          </CardContainer>
        </Link>
      </div>
    </Col>
  );
};
